import { useEffect, useRef } from 'react'

/**
 * Re-reads an account's investments after a background statement upload finished for it.
 *
 * A finished upload refreshes account balances on the app store itself, but individual
 * investments belong to the accounts subtree. This closes that gap so a screen already showing
 * the account picks up the extracted investments without the user reloading.
 *
 * @param {object} params
 * @param {object} params.store App store.
 * @param {object} params.account Accounts-subtree store.
 * @param {string} params.type
 * @param {string|number} params.accountId
 */
const useInvestmentsRefresh = ({ store, account, type, accountId }) => {
  const refreshCount = store.investmentsRefreshCount(accountId)
  const lastSeen = useRef(refreshCount)

  useEffect(() => {
    if (refreshCount === lastSeen.current) return

    lastSeen.current = refreshCount

    account.getInvestments({ type, id: accountId }).catch(err => {
      // The screen already has stale-but-valid data; a failed refresh is not worth a toast.
      console.error('Could not refresh investments after upload', err)
    })
  }, [account, accountId, refreshCount, type])
}

export default useInvestmentsRefresh
